// libraries
import classNames from "classnames/bind";

// components
import { Section } from "src/components/";

// images
import CTABackground from "src/assets/images/home/cta-background.png";
import GooglePlayImage from "src/assets/images/register/play_store.svg";
import AppStoreImage from "src/assets/images/register/app_store.svg";
import PhoneImage from "src/assets/images/home/phone.png";

// styles
import styles from "./styles.module.scss";
const cx = classNames.bind(styles);

const CTA = () => {
  return (
    <div
      className={cx("home-cta-root")}
      style={{ backgroundImage: `url(${CTABackground})` }}
    >
      <Section>
        <div className={cx("cta")}>
          <div className={cx("left-section")}>
            <div>
              <span className={cx("text-larger", "pre-line")}>
                {`Discover what’s near you\n`}
              </span>
              <span className={cx("text-larger")}>From </span>
              <span
                className={cx("text-large", "pre-line")}
              >{`the hottest party’s\n`}</span>
              <span className={cx("text-larger")}>To </span>
              <span className={cx("text-large")}>
                events the whole family will love
              </span>
            </div>
            <a
              className={cx("btn")}
              href="https://play.google.com/store/apps/details?id=com.music_event_app&hl=en_US&gl=US"
              target="_blank"
              rel="noreferrer"
            >
              Get the App
            </a>
            <div className={cx("get-the-app")}>
              <a
                href="https://play.google.com/store/apps/details?id=com.music_event_app&hl=en_US&gl=US"
                target="_blank"
                rel="noreferrer"
              >
                <img src={GooglePlayImage} alt="Get App on google play" />
              </a>
              <a
                href="https://apps.apple.com/us/app/event-moon/id1317300725"
                target="_blank"
                rel="noreferrer"
              >
                <img src={AppStoreImage} alt="Get App on the app store" />
              </a>
            </div>
          </div>
          <div className={cx("right-section")}>
            <img src={PhoneImage} alt="...›" />
          </div>
        </div>
      </Section>
    </div>
  );
};

export default CTA;
